import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
export default function ReadyToPrint() {
  return <section data-section-id="226302" id="secure-your-future" className="dark bg-background text-foreground relative flex min-h-[60vh] items-center justify-center overflow-hidden py-24 sm:py-32">
      {}
      <div className="absolute inset-0 bg-gradient-to-br from-primary/20 via-primary/5 to-transparent opacity-40" />

      {}
      <div className="absolute inset-0 bg-background/60 backdrop-blur-[1px]" />

      <div className="relative z-10 container mx-auto flex flex-col items-center gap-12 px-4 text-center">
        <div className="space-y-6">
          <h2 className="font-default text-6xl font-bold tracking-tighter drop-shadow-2xl sm:text-8xl md:text-7xl text-foreground">
            Let’s Find The Right Finance For You
          </h2>
          <p className="mx-auto max-w-2xl text-xl font-default text-foreground/80 drop-shadow-sm sm:text-2xl md:text-lg">
            Our expert brokers are ready to tailor the perfect lending strategy for your unique goals with premium financial solutions.
          </p>
        </div>

        <div className="relative mt-4">
          {}
          <div className="absolute -inset-4 animate-pulse rounded-full bg-primary/20 blur-2xl" />

          <Link to="/contact/">
            <Button size="lg" className="group relative h-14 rounded-xl bg-primary px-8 text-lg font-semibold text-primary-foreground shadow-xl transition-all duration-300 hover:-translate-y-1 hover:bg-primary/90 hover:shadow-2xl">
              Book Consultation
              <ArrowRight className="ml-2 size-5 transition-transform duration-300 group-hover:translate-x-1" />
            </Button>
          </Link>
        </div>
      </div>
    </section>;
}